import OpeningInwestycje from "./OpeningInwestycje";
export default OpeningInwestycje;